import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import '../../styles/vim-pay.css';
import '../../styles/vim-pay-nav.css';

export function VimPayLayout() {
  return (
    <div className="vim-pay-shell">
      <header className="vim-pay-header">
        <Link className="vim-pay-brand" to="/pay" aria-label="VIM Pay home">
          <span className="vim-pay-brand-mark">VIM</span>
          <span>
            <strong>VIM Pay</strong>
            <small>Talent & Crew Pay Portal</small>
          </span>
        </Link>
        <nav className="vim-pay-nav" aria-label="VIM Pay">
          <NavLink end to="/pay">Dashboard</NavLink>
          <NavLink to="/pay/onboarding">Pay Profile</NavLink>
          <NavLink to="/pay/tax">Tax</NavLink>
          <NavLink to="/pay/projects">Projects</NavLink>
          <NavLink to="/pay/payments">Payments</NavLink>
          <NavLink className="vim-pay-site-link" to="/profile">Account Workspaces</NavLink>
          <a className="vim-pay-site-link" href="/home">WatchVIM.com</a>
        </nav>
      </header>
      <main className="vim-pay-main">
        <Outlet />
      </main>
      <footer className="vim-pay-footer">
        <span>VIM Media talent & crew payments</span>
        <span>PayPal • Zelle • ACH only</span>
      </footer>
    </div>
  );
}
